import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {MatChipInputEvent} from '@angular/material/chips';
import { Observable, Subject } from 'rxjs';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-transporters',
  templateUrl: './transporters.component.html',
  styleUrls: ['./transporters.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class TransportersComponent implements OnInit {

  constructor(public parent: DashboardComponent, private service:SharedService, private managementService: ManagementServiceService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) {

    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

      // Debounce search.
      this.partnerSearchTermUpdate.pipe(
        debounceTime(200),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.GetPartnersFiltered();
          }
        });

      // Debounce UIT search
      this.uitSearchTermUpdate.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetUITNumbersFiltered();
        });

  }

  GetPartnersFiltered(){
    var request = {
      SearchTerm:this.PartnersFilter.SearchTerm,
      CountryID:this.PartnersFilter.Country?.ID,
      PageIndex:this.PartnersFilter.Pager.PageIndex,
      PageSize:this.PartnersFilter.Pager?.PageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.PartnersFilter.Company?.ID
    };
  
    this.parent.loading = true;
  
    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.PartnersFilter.Pager.TotalCount = response["Count"];
      }
   
      this.parent.loading = false;
    });
  }

  Partners:any[];
  PartnersFilter: {[k: string]: any} = {};
  Filter: {[k: string]: any} = {};
  ShippingCompanies:any[];
  MasterData: {[k: string]: any} = {};
  partnerSearchTermUpdate = new Subject<string>();
  EFacturaStepOne:boolean = false;
  EFacturaFilter: {[k: string]: any} = {};

  // UIT Numbers Tab Properties
  selectedMainTab: number = 1; // 1 = Transport Companies, 2 = UIT Numbers
  selectedUITDirection: number = 1; // 1 = Export, -1 = Import
  UITNumbers: any[] = [];
  UITFilter: {[k: string]: any} = {};
  uitSearchTermUpdate = new Subject<string>();
  loadingUITNumbers: boolean = false;

  // Set the minimum date (60 days behind) and maximum date (today)
  today = moment().format('YYYY-MM-DD');
  pastDateLimit = moment().subtract(60, 'days');

  EFacturaFromDate = new FormControl(moment()); // Initialize with today's date
  EFacturaToDate = new FormControl({value: this.today});    // Initialize with today's date

  // For the maxDate and minDate restrictions in the template
  minDate = this.pastDateLimit.toDate(); // Convert moment to Date object
  maxDate = this.today;         // Convert moment to Date object

  showFilter:boolean;
  loadingEFacturaDocuments:boolean;

  ngOnInit(): void {
    this.InitializeFilter();
    this.GetShippingMasterData();
    this.InitializePartnersFilter();
    this.InitializeEFacturaFilter();
    this.InitializeUITFilter();
  }

  InitializeEFacturaFilter(){
    this.EFacturaFilter = {};
    this.EFacturaFilter.FromDate = null;
    this.EFacturaFilter.ToDate = null;

    this.EFacturaFilter.VATNumber = "";
    this.EFacturaFilter.CreateAutomaticReceptions = false;
    this.EFacturaFilter.Period = {};
    this.EFacturaFilter.Period = null;

    this.EFacturaFilter.Pager = {};
    this.EFacturaFilter.Pager.PageIndex = 1;
    this.EFacturaFilter.Pager.PageSize = 50;
    this.EFacturaFilter.Pager.TotalCount = 0;

    this.EFacturaFilter.GetCompanyNames = false;
  }

  InitializeFilter(){
    this.Filter = {};
    this.Filter.Product = "";

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.InvoiceDocType = {};
    this.Filter.InvoiceDocType = null;

    this.GetShippingCompaniesFullData();
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.EFacturaFilter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
    this.EFacturaFilter.Period = null;
  }

  activeFilters:{[k: string]: any} = [];

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.showFilter = false;
      this.GetShippingCompaniesFullData();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "InvoiceDocType"){
      this.Filter.InvoiceDocType = null;
    }
    else if(filterType == "Product"){
      this.Filter.Product = null;
    }
   

    this.GetShippingCompaniesFullData();
}

  InitializePartnersFilter(){
    this.PartnersFilter = {};
    this.PartnersFilter.SearchTerm = "";

    this.PartnersFilter.Pager = {};
    this.PartnersFilter.Pager.PageIndex = 1;
    this.PartnersFilter.Pager.PageSize = 50;
    this.PartnersFilter.Pager.TotalCount = 0;

    this.PartnersFilter.Company = {};
    this.PartnersFilter.Company = null;
    
    this.PartnersFilter.Country = {};
    this.PartnersFilter.Country = null;
  }

  GetShippingCompaniesFullData(page = 1){
    
    this.Filter.Pager.PageIndex = page;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };
   
      this.parent.loading = true;

      this.service.GetShippingCompaniesFullData(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.ShippingCompanies = JSON.parse(JSON.stringify(response["ShippingCompanies"]));
          this.Filter.Pager = JSON.parse(JSON.stringify(response["Pager"]));
        }
     
        this.parent.loading = false;
      });
  }

  bodyLoading:boolean = false;

  GetPartner(s:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:s.Partner?.ID,
      WithAllData:true,
    };
   
      this.bodyLoading = true;

      this.service.GetPartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
          
        }
        else if(response["Status"] == 1){
          s.Partner = JSON.parse(JSON.stringify(response["Partner"]));
        }
     
        this.bodyLoading = false;
      });
  }
  
  ShippingWays:any[];
  ShippingServiceTypes:any[];
  ShippingResponsabilities:any[];
  WeightTypes:any[];
  ShippingMasterData:any;

CustomsStations:any[];
ETransportDocumentTypes:any[];
ETransportMeasuringUnits:any[];
ETransportOperationReasons:any[];
ETransportOperationTypes:any[];
ETransportCustomsBureaus:any[];
GeneralDocTypes:any[];

GeneralDocType:any;
ETransportCustomsStation:any;
ETransportDocumentType:any;
ETransportMeasuringUnit:any;
ETransportOperationReason:any;
ETransportOperationType:any;
UITShippingCompany:any;
UITAutoPlatesNumber:string;
ETransportCustomsBureau:any;

  GetShippingMasterData(WithROETransportData:boolean = true){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      WithROETransportData:true,
   };
  
   this.parent.loading = true;
  
  this.service.GetShippingMasterData(request).subscribe(response => {
  
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.MasterData = JSON.parse(JSON.stringify(response));
      this.ShippingWays = response["ShippingWays"];
      this.ShippingServiceTypes = response["ShippingServiceTypes"];
      this.ShippingResponsabilities = response["ShippingResponsabilities"];
      this.ShippingCompanies = response["ShippingCompanies"];
      this.WeightTypes = response["WeightTypes"];

      this.ShippingMasterData = response;

      if(WithROETransportData == true){
        this.GeneralDocTypes = JSON.parse(JSON.stringify(this.ShippingMasterData.GeneralDocTypes));
        this.CustomsStations = JSON.parse(JSON.stringify(this.ShippingMasterData.CustomsStations));
        this.ETransportDocumentTypes = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportDocumentTypes));
        this.ETransportMeasuringUnits = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportMeasuringUnits));
        this.ETransportOperationReasons = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportOperationReasons));
        this.ETransportOperationTypes = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportOperationTypes));
        this.ETransportCustomsBureaus = JSON.parse(JSON.stringify(this.ShippingMasterData.ETransportCustomsBureaus));

        // Currencies for UIT shipment value currency selection
        this.Currencies = this.ShippingMasterData.Currencies ? JSON.parse(JSON.stringify(this.ShippingMasterData.Currencies)) : [];
        // Default to EUR (ID=2) if available
        this.UITCurrency = this.Currencies.find(c => c.ID === 2) || this.Currencies[0];
      }
    }
  
    this.parent.loading = false;
   });
   }

   SelectShippingCompany(s:any){
    this.ShippingCompanies.forEach(element => {
      if(s.ID == element.ID){
        element.IsSelected = !element.IsSelected;

        if(element.IsSelected == true){
          this.GetPartner(element);
        }
      }
      else{
        element.IsSelected = false;
      }
    });
   }

   compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

SelectEmailSupportCategory(supportCategory:any, s:any){

  this.InitializeNewEmailSupportCategory();

  s.SupportContacts.forEach(element => {
    if(element.Category.ID == supportCategory.Category.ID){
      element.IsSelected = !element.IsSelected;
    }
    else{
      element.IsSelected = false;
    }
    
  });
}

ResetPartnersSearch(){
  this.PartnersFilter.SearchTerm = "";
  this.Partners = [];
  this.NewShippingCompany.Partner = {};
  this.NewShippingCompany.Partner = null;
  this.UITPartner = null;
}

NewEmailSupportCategory:any;

InitializeNewEmailSupportCategory(){
  this.NewEmailSupportCategory = {};
  this.NewEmailSupportCategory.Email = "";
  this.NewEmailSupportCategory.ID = 0;
}

DeleteShippingCompanySupportEmail(DBID:any, sc:any, e:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    DBID:DBID
 };

 this.parent.loading = true;

this.service.DeleteShippingCompanySupportEmail(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
    sc.Emails = sc.Emails.filter(x => x.ID != e.ID);
  }

  this.parent.loading = false;
 });
 }

AddEmailToSupportCategory(CategoryID:any, ShippingCompanyID:any){
  
  this.NewEmailSupportCategory.CategoryID = CategoryID;
  this.NewEmailSupportCategory.ShippingCompanyID = ShippingCompanyID;

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Email:this.NewEmailSupportCategory,
 };

 this.parent.loading = true;

this.service.AddUpdateShippingCompanySupportEmail(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
    this.ShippingCompanies.forEach(s => {
      if(s.ID == ShippingCompanyID){
        s.SupportContacts.forEach(sc => {
        if(sc.Category.ID == CategoryID){
          sc.Emails.push(JSON.parse(JSON.stringify(response["Email"])));
        }
        });
      }
    });  
  }

  this.InitializeNewEmailSupportCategory();
  this.parent.loading = false;
 });
}

ChoosePartner(p:any, s:any){
  this.ShippingCompanies.forEach(element => {
    if(element.ID == s.ID){
      element.Partner = p;
      this.PartnersFilter.SearchTerm = p.Name;
    }
  });

  this.ResetPartnersSearch();
}

loadingShippingCompanyUpdate:boolean = false;

PrepareForTransportationCostsEFactura(s:any){
  this.EFacturaFilter.VATNumber = s.Partner.VAT;
  this.EFacturaStepOne = true;
}

AddUpdateShippingCompany(s:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingCompany:s,
 };

 this.loadingShippingCompanyUpdate = true;

this.service.AddUpdateShippingCompany(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){

    for(var i=0;i<this.ShippingCompanies.length;i++){
      if(this.ShippingCompanies[i].ID == s.ID){
        this.ShippingCompanies[i] = JSON.parse(JSON.stringify(response["ShippingCompany"]));
        this.ShippingCompanies[i].IsSelected = false;
      }
    }

  }

  this.loadingShippingCompanyUpdate = false;
 });
 }

 AllocateTransportationCostsOnDocuments(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    EFacturaFilter:this.EFacturaFilter,
    ShippingCompany:this.ShippingCompanies.filter(x => x.IsSelected == true)[0],
 };

 this.loadingEFacturaDocuments = true;

this.service.AllocateTransportationCostsOnDocuments(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
  
  }

  this.loadingEFacturaDocuments = false;
 });
 }

 NewShippingCompany: {[k: string]: any} = {};
 ShowOpenNewTransporterPopUp:boolean = false;

 OpenNewTransporterPopUp(){

  this.ShippingCompanies.forEach(element => {
    element.IsSelected = false;
  });

  this.NewShippingCompany = {};
  this.NewShippingCompany.Name = "";
  this.NewShippingCompany.HasTrackingURL = false;
  this.NewShippingCompany.HasAPI = false;
  this.NewShippingCompany.Category = null;
  this.NewShippingCompany.Partner = null;
  this.NewShippingCompany.ShippingServiceTypes = [];
  this.NewShippingCompany.ShippingServiceTypes = JSON.parse(JSON.stringify(this.MasterData.ShippingServiceTypes));
  this.NewShippingCompany.SupportContacts = [];

  this.ShowOpenNewTransporterPopUp = true;
 }

 ChoosePartnerNewTransporter(p:any){
  this.NewShippingCompany.Partner = JSON.parse(JSON.stringify(p));
  this.PartnersFilter.SearchTerm = JSON.parse(JSON.stringify(p.Name));
  this.Partners = [];
}

loadingUIT = false;

AddUpdateShippingCompanyWithDetails(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    ShippingCompany:this.NewShippingCompany,
 };

 this.parent.loading = true;

this.service.AddUpdateShippingCompanyWithDetails(request).subscribe(response => {

  if(response["Status"] != 1){
   this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
    this.GetShippingCompaniesFullData(1);
  }

  this.parent.loading = true;
 });
 }

 ShowETransportStepOne:boolean = false;
 ShowETransportStepZero:boolean = false;
 DocumentBodyLoading:boolean = false;

 PrepareETransportStep0(s:any){
  this.UITShippingCompany = JSON.parse(JSON.stringify(s));
  this.ShowETransportStepZero = true;
 }

 PrepareETransportStep1(Client:any){
  this.GetShippingMasterData(true);
  this.PrepareGenerateUITDataUX(Client, this.GeneralDocType?.ID);
}

UITPartner:any;

ChoosePartnerNewUIT(p:any){
  this.UITPartner = JSON.parse(JSON.stringify(p));
  this.PartnersFilter.SearchTerm = JSON.parse(JSON.stringify(p.Name));
  this.Partners = [];
}

PrepareGenerateUITDataUX(Partner:any, GeneralDocTypeID:number){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:Partner,
    GeneralDocType:GeneralDocTypeID
  };

  this.DocumentBodyLoading = true;

  this.service.PrepareGenerateUITDataUX(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ETransportCustomsStation = response["CustomsStation"];
      this.ETransportDocumentType = response["ETransportDocumentType"];
      this.ETransportMeasuringUnit = response["ETransportMeasuringUnit"];
      this.ETransportOperationReason = response["ETransportOperationReason"];
      this.ETransportOperationType = response["ETransportOperationType"];
      this.UITAutoPlatesNumber = response["AutoPlatesNumber"];
      this.ETransportCustomsBureau = response["ETransportCustomsBureau"];

      this.ShowETransportStepOne = true;
    }

    this.DocumentBodyLoading = false;
  });
}

UploadETransportInvoice(i:any){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Document:i,
    AutoPlatesNumber:this.UITAutoPlatesNumber,
    CustomsStation:this.ETransportCustomsStation,
    ETransportDocumentType:this.ETransportDocumentType,
    ETransportMeasuringUnit:this.ETransportMeasuringUnit,
    ETransportOperationReason:this.ETransportOperationReason,
    ETransportOperationType:this.ETransportOperationType,
    ETransportCustomsBureau:this.ETransportCustomsBureau,
    ShippingCompany:this.UITShippingCompany,
  };

  this.DocumentBodyLoading = true;

  this.service.UploadETransportInvoice(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      
    }

    this.DocumentBodyLoading = false;
  });
}

TotalShipmentValueNOVAT:number;
TotalShipmentValueNOVATInput:string;
ShipmentWeightKGs:number;
ShipmentWeightKGsInput:string;
DocumentNumber:string;
Currencies:any[] = [];
UITCurrency:any;

// Normalize shipment value from string input (handles EU/US formats like "19.265,27" or "19,265.27")
// Updates both the numeric value and the input display
NormalizeShipmentValue(value: string) {
  this.TotalShipmentValueNOVAT = this.parseNumberFromAnyFormat(value);
  // Update the input to show the normalized number
  this.TotalShipmentValueNOVATInput = this.TotalShipmentValueNOVAT != null ? String(this.TotalShipmentValueNOVAT) : '';
}

// Normalize shipment weight from string input
// Updates both the numeric value and the input display
NormalizeShipmentWeight(value: string) {
  this.ShipmentWeightKGs = this.parseNumberFromAnyFormat(value);
  // Update the input to show the normalized number
  this.ShipmentWeightKGsInput = this.ShipmentWeightKGs != null ? String(this.ShipmentWeightKGs) : '';
}

/**
 * Parse a number from any format (US, EU, or mixed).
 * Handles:
 * - "1029.99" → 1029.99 (US format)
 * - "1,029.99" → 1029.99 (US format with thousands)
 * - "1.029,99" → 1029.99 (EU format with thousands)
 * - "1029,99" → 1029.99 (EU format)
 * - "19.265,27" → 19265.27 (EU format with thousands)
 */
parseNumberFromAnyFormat(value: any): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  // Convert to string
  let str = String(value).trim();

  // Remove any whitespace
  str = str.replace(/\s+/g, '');

  // If empty after trimming, return null
  if (str === '') {
    return null;
  }

  // Count dots and commas
  const dotCount = (str.match(/\./g) || []).length;
  const commaCount = (str.match(/,/g) || []).length;

  // Determine format based on separators
  if (dotCount === 0 && commaCount === 0) {
    // No separators - just a number
    const num = parseFloat(str);
    return isNaN(num) ? null : num;
  } else if (dotCount === 1 && commaCount === 0) {
    // Only dot - assume decimal separator (US format)
    const num = parseFloat(str);
    return isNaN(num) ? null : num;
  } else if (dotCount === 0 && commaCount === 1) {
    // Only comma - could be thousands or decimal separator
    const commaPos = str.indexOf(',');
    const afterComma = str.substring(commaPos + 1);

    if (afterComma.length <= 2) {
      // Decimal separator (EU format)
      str = str.replace(',', '.');
    } else {
      // Thousands separator
      str = str.replace(',', '');
    }

    const num = parseFloat(str);
    return isNaN(num) ? null : num;
  } else if (dotCount > 1 && commaCount === 0) {
    // Multiple dots - assume thousands separators (EU format without decimals)
    str = str.replace(/\./g, '');
    const num = parseFloat(str);
    return isNaN(num) ? null : num;
  } else if (commaCount > 1 && dotCount === 0) {
    // Multiple commas - assume thousands separators
    str = str.replace(/,/g, '');
    const num = parseFloat(str);
    return isNaN(num) ? null : num;
  } else if (dotCount >= 1 && commaCount >= 1) {
    // Both dots and commas - determine which is decimal separator
    const lastDotPos = str.lastIndexOf('.');
    const lastCommaPos = str.lastIndexOf(',');

    if (lastCommaPos > lastDotPos) {
      // Comma is decimal separator (EU format: "19.265,27")
      str = str.replace(/\./g, ''); // Remove thousand separators
      str = str.replace(',', '.'); // Convert decimal separator
    } else {
      // Dot is decimal separator (US format: "19,265.27")
      str = str.replace(/,/g, ''); // Remove thousand separators
    }

    const num = parseFloat(str);
    return isNaN(num) ? null : num;
  }

  // Default fallback
  const num = parseFloat(str.replace(/[^0-9.-]/g, ''));
  return isNaN(num) ? null : num;
}

ETransportDetails:any;
ShowETransportDetails:boolean = false;

GenerateUIT(){
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    AutoPlatesNumber:this.UITAutoPlatesNumber,
    CustomsStation:this.ETransportCustomsStation,
    ETransportDocumentType:this.ETransportDocumentType,
    ETransportMeasuringUnit:this.ETransportMeasuringUnit,
    ETransportOperationReason:this.ETransportOperationReason,
    ETransportOperationType:this.ETransportOperationType,
    ETransportCustomsBureau:this.ETransportCustomsBureau,
    ShippingCompany:this.UITShippingCompany,
    UITPartner:this.UITPartner,
    GeneralDocType:this.GeneralDocType.ID,
    TotalShipmentValueNOVAT:this.TotalShipmentValueNOVAT,
    ShipmentWeightKGs:this.ShipmentWeightKGs,
    DocumentNumber:this.DocumentNumber,
    Currency:this.UITCurrency
  };

  this.DocumentBodyLoading = true;

  this.service.GenerateUIT(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-danger-snackbar");
      this.ShowETransportDetails = false;
      this.ETransportDetails = null;
    }
    else if(response["Status"] == 1){
      this.ETransportDetails = JSON.parse(JSON.stringify(response["ETransportDetails"]));
      this.ShowETransportDetails = true;
    }

    this.ShowETransportStepOne = false;
    this.ShowETransportStepZero = false;
    this.DocumentBodyLoading = false;
  });
}

CloseUIT(){
  this.ShowETransportDetails = false;
}

copyUITToClipboard(uit: string) {
  if (uit) {
    navigator.clipboard.writeText(uit).then(() => {
      console.log('UIT copied to clipboard:', uit);
    }).catch(err => {
      console.error('Failed to copy UIT:', err);
    });
  }
}

// ========== UIT Numbers Tab Methods ==========

onSelectMainTab(tab: number) {
  this.selectedMainTab = tab;
  if (tab === 2 && (!this.UITNumbers || this.UITNumbers.length === 0)) {
    this.GetUITNumbersFiltered();
  }
}

onSelectUITDirection(direction: number) {
  this.selectedUITDirection = direction;
  this.UITFilter.ShippingDirection = { ID: direction };
  this.UITFilter.Pager.PageIndex = 1;
  this.GetUITNumbersFiltered();
}

InitializeUITFilter() {
  this.UITFilter = {};
  this.UITFilter.SearchTerm = "";
  this.UITFilter.ShippingDirection = { ID: this.selectedUITDirection };

  this.UITFilter.Pager = {};
  this.UITFilter.Pager.PageIndex = 1;
  this.UITFilter.Pager.PageSize = 50;
  this.UITFilter.Pager.TotalCount = 0;
  this.UITFilter.Pager.Pages = 1;
}

GetUITNumbersFiltered(page: number = 1) {
  this.UITFilter.Pager.PageIndex = page;

  var request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Filter: {
      SearchTerm: this.UITFilter.SearchTerm,
      ShippingDirection: this.UITFilter.ShippingDirection,
      Pager: this.UITFilter.Pager
    }
  };

  this.loadingUITNumbers = true;
  this.parent.loading = true;

  this.managementService.GetUITNumbersFiltered(request).subscribe({
    next: (response) => {
      try {
        if (response["Status"] != 1) {
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        } else if (response["Status"] == 1) {
          this.UITNumbers = response["UITDetailsList"] || [];
          this.UITFilter.Pager.TotalCount = response["Pager"]?.TotalCount || 0;
          var pageSize = this.UITFilter.Pager.PageSize || 25;
          this.UITFilter.Pager.Pages = Math.ceil(this.UITFilter.Pager.TotalCount / pageSize) || 1;
        }
      } catch (e) {
        console.error('GetUITNumbersFiltered parse error:', e);
      }

      this.loadingUITNumbers = false;
      this.parent.loading = false;
    },
    error: (err) => {
      console.error('GetUITNumbersFiltered error:', err);
      this.loadingUITNumbers = false;
      this.parent.loading = false;
    }
  });
}

}
